export const ENV = 'prod'

export const HOST = ENV === 'prod' ? 'https://admin.capternal.com' : 'http://localhost:4400'
export const API = '/api/cap-admin'
export const API_EMPLOYEE = '/api/employee'
export const EMPLOYEE_LOGIN = `${HOST}/api/cap-admin/employee/login`

export const isDataModeOn = false

//customers section 
export const CUSTOMERS = `${HOST}${API}/`
export const CUSTOMERS_ADD = `${HOST}${API}/`


//Cluster section 
export const CLUSTERS = `${HOST}${API}/cluster/clusters`
export const CLUSTERS_ADD = `${HOST}${API}/cluster/add`
export const CLUSTERS_DETAILS = `${HOST}${API}/cluster/details`

//Users Section
export const USERS = `${HOST}${API}/users`
export const USERS_ADD = `${HOST}${API}/add`
export const USERS_DETAILS = `${HOST}${API}/details`

// API
export const API_LIST = `${HOST}${API}/apis/list`
export const ADD_API = `${HOST}${API}/apis/add`
export const EDIT_API = `${HOST}${API}/apis/edit`
export const GET_API = `${HOST}${API}/apis/get`

export const ADD_API_COLLECTION = `${HOST}${API}/apis/collection/add`

// Department Routes
export const DEPARTMENT = `${HOST}${API}/master/department/list`
export const ADD_DEPARTMENT = `${HOST}${API}/master/department/add`
export const EDIT_DEPARTMENT = `${HOST}${API}/master/department/edit`
export const GET_DEPARTMENT = `${HOST}${API}/master/department/get`
export const DELETE_DEPARTMENT = `${HOST}${API}/master/department/delete`

// Designation Routes
export const DESIGNATION = `${HOST}${API}/master/designation/list`
export const ADD_DESIGNATION = `${HOST}${API}/master/designation/add`
export const EDIT_DESIGNATION = `${HOST}${API}/master/designation/edit`
export const GET_DESIGNATION = `${HOST}${API}/master/designation/get`
export const DELETE_DESIGNATION = `${HOST}${API}/master/designation/delete`

// Client
export const CLIENT = `${HOST}${API}/master/client/list`
export const ADD_CLIENT = `${HOST}${API}/master/client/add`
export const EDIT_CLIENT = `${HOST}${API}/master/client/edit`
export const GET_CLIENT = `${HOST}${API}/master/client/get`
export const DELETE_CLIENT = `${HOST}${API}/master/client/delete`

// Company Routes
export const COMPANY = `${HOST}${API}/master/company/list`
export const ADD_COMPANY = `${HOST}${API}/master/company/add`
export const EDIT_COMPANY = `${HOST}${API}/master/company/edit`
export const GET_COMPANY = `${HOST}${API}/master/company/get`
export const DELETE_COMPANY = `${HOST}${API}/master/company/delete`

// master dropdown
export const MASTER_LIST = `${HOST}/api/cap-admin/master/list`
export const COUNTRY = `${HOST}${API}/master/country`
export const STATE = `${HOST}${API}/master/state`
export const CITY = `${HOST}${API}/master/city`
export const GET_PERMISSION = `${HOST}${API}/`
export const PERMISSION_ADD = `${HOST}${API}/`

// Employee Routes
export const ADD_EMPLOYEE = `${HOST}${API}/employee/add`
export const EDIT_EMPLOYEE = `${HOST}${API}/employee/edit`
export const EMPLOYEE = `${HOST}${API}/employee/list`
export const GET_EMPLOYEE = `${HOST}${API}/employee/get`
export const EMPLOYEE_DETAILS = `${HOST}${API}/employee/view`
export const EMPLOYEE_LIST = `${HOST}${API}/employee/employee-list`
export const CHANGE_PASSWORD = `${HOST}${API}/employee/change-password`

// Employee Activity Routes
export const ADD_ACTIVITY = `${HOST}${API}/employee/activities/add`
export const LIST_ACTIVITY = `${HOST}${API}/employee/activities/list`
export const GET_ACTIVITY = `${HOST}${API}/employee/activities/get`

// Role Routes
export const ROLE = `${HOST}${API}/master/role/list`
export const ADD_ROLE = `${HOST}${API}/master/role/add`
export const EDIT_ROLE = `${HOST}${API}/master/role/edit`
export const GET_ROLE = `${HOST}${API}/master/role/get`
export const DELETE_ROLE = `${HOST}${API}/master/role/delete`

// Modules Routes
export const MODULES = `${HOST}${API}/master/modules`
export const ADD_MODULES = `${HOST}${API}/master/modules/add`
export const EDIT_MODULES = `${HOST}${API}/master/modules/edit`
export const GET_MODULES = `${HOST}${API}/master/modules/get`
export const MODULES_DETAILS = `${HOST}${API}/master/modules/detail`

// Role Module
export const ADD_ROLE_MODULES = `${HOST}${API}/master/role-modules/add`
export const GET_ROLE_MODULES = `${HOST}${API}/master/role-modules/get`

// Leave Setting
export const GET_ANNUAL_LEAVE = `${HOST}${API}/cap-master/annual-leave`

// Leave Employee
export const LEAVES = `${HOST}${API}/leaves/list`
export const ADD_LEAVES = `${HOST}${API}/leaves/add`
export const GET_LEAVES = `${HOST}${API}/leaves/get`
export const EDIT_LEAVES = `${HOST}${API}/leaves/edit`
export const DELETE_LEAVES = `${HOST}${API}/leaves/delete`
export const ASSIGNEE_DROPDOWN_LIST = `${HOST}${API}/leaves/assignee`

// Leave Admin
export const LEAVES_ADMIN = `${HOST}${API}/leaves/admin-list`
export const ADD_LEAVES_ADMIN = `${HOST}${API}/leaves/admin/add`
export const GET_LEAVES_ADMIN = `${HOST}${API}/leaves/get`
export const EDIT_LEAVES_ADMIN = `${HOST}${API}/leaves/admin-edit`
export const DELETE_LEAVES_ADMIN = `${HOST}${API}/leaves/delete`


// Project
export const ADD_PROJECT = `${HOST}${API}/project/add`
export const PROJECT = `${HOST}${API}/project/list`
export const GET_PROJECT = `${HOST}${API}/project/get`
export const EDIT_PROJECT = `${HOST}${API}/project/edit`
export const ADD_PROJECT_MODULE = `${HOST}${API}/project/project-module/add`
export const PROJECT_MODULE = `${HOST}${API}/project/project-module/list`
export const DELETE_PROJECT = `${HOST}${API}/project/delete`
export const DELETE_PROJECT_MODULE = `${HOST}${API}/project/project-module/delete`
export const COMPLETED_PROJECT_MODULE = `${HOST}${API}/project/project-module/completed`
export const EDIT_PROJECT_MODULE = `${HOST}${API}/project/project-module/edit`
export const GET_PROJECT_MODULE = `${HOST}${API}/project/project-module/get`


// Task Routes
export const ADD_TASK = `${HOST}${API}/project/task-add`
export const TASK = `${HOST}${API}/project/task-list`
export const DELETE_TASK = `${HOST}${API}/project/task-delete`
export const HOLD_TASK = `${HOST}${API}/project/task-on-hold`
export const EDIT_TASK = `${HOST}${API}/project/task-edit`
export const GET_TASK = `${HOST}${API}/project/task-get`
export const ASSIGNED_PROJECT_LIST = `${HOST}${API}/project/assigned-projects-list`
export const TASK_STATUS_LIST = `${HOST}${API}/project/task-status-list`
export const GET_TASK_DETAIL = `${HOST}${API}/project/task-get-detail`
export const TASK_STATUS_CHANGE = `${HOST}${API}/project/change-task-status`

// Task Board
export const TASKBOARD_LIST = `${HOST}${API}/project/taskboard`

// Holiday
export const HOLIDAY = `${HOST}${API}/holiday/list`
export const ADD_HOLIDAY = `${HOST}${API}/holiday/add`
export const EDIT_HOLIDAY = `${HOST}${API}/holiday/edit`
export const GET_HOLIDAY = `${HOST}${API}/holiday/get`
export const DELETE_HOLIDAY = `${HOST}${API}/holiday/delete`

// Account Expense
export const ACCOUNT_EXPENSE = `${HOST}${API}/account-master/accountexpensemaster-list`
export const ADD_ACCOUNT_EXPENSE = `${HOST}${API}/account-master/accountexpensemaster-add`
export const EDIT_ACCOUNT_EXPENSE = `${HOST}${API}/account-master/accountexpensemaster-edit`
export const GET_ACCOUNT_EXPENSE = `${HOST}${API}/account-master/accountexpensemaster-get`
export const DELETE_ACCOUNT_EXPENSE = `${HOST}${API}/account-master/accountexpensemaster-delete`

// Taxes
export const TAXES = `${HOST}${API}/account-master/tax-list`
export const ADD_TAXES = `${HOST}${API}/account-master/tax-add`
export const EDIT_TAXES = `${HOST}${API}/account-master/tax-edit`
export const GET_TAXES = `${HOST}${API}/account-master/tax-get`
export const DELETE_TAXES = `${HOST}${API}/account-master/tax-delete`

// Expenses
export const EXPENSES = `${HOST}${API}/account-master/expense-list`
export const ADD_EXPENSES = `${HOST}${API}/account-master/expense-add`
export const EDIT_EXPENSES = `${HOST}${API}/account-master/expense-edit`
export const GET_EXPENSES = `${HOST}${API}/account-master/expense-get`
export const DELETE_EXPENSES = `${HOST}${API}/account-master/expense-delete`

// Attendance
export const ATTENDANCE = `${HOST}${API}/attendance/list`
export const ADD_ATTENDANCE = `${HOST}${API}/attendance/add`
export const GET_ATTENDANCE = `${HOST}${API}/attendance/get`
export const EDIT_ATTENDANCE = `${HOST}${API}/attendance/edit`
export const ADD_PROFILE_ATTENDANCE = `${HOST}${API}/attendance/add/profile`

// Attendance - Admin
export const ATTENDANCE_ADMIN = `${HOST}${API}/attendance/admin-attendance-list`

// Timesheet
export const TIMESHEET = `${HOST}${API}/timesheet/list`
export const ADD_TIMESHEET = `${HOST}${API}/timesheet/add`
export const GET_TIMESHEET = `${HOST}${API}/timesheet/get`
export const EDIT_TIMESHEET = `${HOST}${API}/timesheet/edit`
export const DELETE_TIMESHEET = `${HOST}${API}/timesheet/delete`

// Event
export const EVENT = `${HOST}${API}/calendar/list-event`
export const ADD_EVENT = `${HOST}${API}/calendar/add-event`
export const GET_EVENT = `${HOST}${API}/calendar/get-event`
export const EDIT_EVENT = `${HOST}${API}/calendar/update-event`
export const DELETE_EVENT = `${HOST}${API}/calendar//delete-event`

// Asset
export const ASSET = `${HOST}${API}/account-master/assets-list`
export const ADD_ASSET = `${HOST}${API}/account-master/assets-add`
export const GET_ASSET = `${HOST}${API}/account-master/assets-get`
export const EDIT_ASSET = `${HOST}${API}/account-master/assets-edit`
export const DELETE_ASSET = `${HOST}${API}/account-master/assets-delete`

// Employee Salary
export const EMPLOYEE_SALARY = `${HOST}${API}/account-master/employeesalary-list`
export const ADD_EMPLOYEE_SALARY = `${HOST}${API}/account-master/employeesalary-add`
export const GET_EMPLOYEE_SALARY = `${HOST}${API}/account-master/employeesalary-get`
export const EDIT_EMPLOYEE_SALARY = `${HOST}${API}/account-master/employeesalary-edit`
export const DELETE_EMPLOYEE_SALARY = `${HOST}${API}/account-master/employeesalary-delete`
export const GENERATE_EMPLOYEE_SALARY = `${HOST}${API}/account-master/employeesalary-generate`

// Employee Salary sheet
export const EMPLOYEE_SALARY_SHEET = `${HOST}${API}/account-master/employeesalarysheet-list`
export const ADD_EMPLOYEE_SALARY_SHEET = `${HOST}${API}/account-master/employeesalarysheet-add`
export const GET_EMPLOYEE_SALARY_SHEET = `${HOST}${API}/account-master/employeesalarysheet-get`
export const EDIT_EMPLOYEE_SALARY_SHEET = `${HOST}${API}/account-master/employeesalarysheet-edit`
export const DELETE_EMPLOYEE_SALARY_SHEET = `${HOST}${API}/account-master/employeesalarysheet-delete`

// Invoice
export const INVOICE = `${HOST}${API}/account-master/invoices-list`
export const ADD_INVOICE = `${HOST}${API}/account-master/invoices-add`
export const GET_INVOICE = `${HOST}${API}/account-master/invoices-get`
export const EDIT_INVOICE = `${HOST}${API}/account-master/invoices-edit`
export const DELETE_INVOICE = `${HOST}${API}/account-master/invoices-delete`

// Estimate
export const ESTIMATE = `${HOST}${API}/account-master/estimates-list`
export const ADD_ESTIMATE = `${HOST}${API}/account-master/estimates-add`
export const GET_ESTIMATE = `${HOST}${API}/account-master/estimates-get`
export const EDIT_ESTIMATE = `${HOST}${API}/account-master/estimates-edit`
export const DELETE_ESTIMATE = `${HOST}${API}/account-master/estimates-delete`

// Dashboard
export const GET_DASHBOARD = `${HOST}/api/cap-admin/master/dashboard/get`

//User documents
export const GET_USER = `${HOST}/api/cap-admin/user/list`
export const ADD_USER = `${HOST}/api/cap-admin/user/add`
export const ADD_USER_DOCUMENT = `${HOST}/api/cap-admin/user/add/document`
export const VIEW_USER = `${HOST}/api/cap-admin/user/get/document`
export const EDIT_USER = `${HOST}/api/cap-admin/user/edit`
export const DELETE_USER = `${HOST}/api/cap-admin/user/delete`
export const DELETE_DOCUMENT = `${HOST}/api/cap-admin/user/document/delete`
export const EDIT_DOCUMENT = `${HOST}/api/cap-admin/user/edit/document/type`

//Reports
export const EMPLOYEE_REPORT = `${HOST}/api/cap-admin/employee/list`
export const EXPENSE_REPORT = `${HOST}/api/cap-admin/employee/list`
export const INVOICE_REPORT = `${HOST}/api/cap-admin/employee/list`
export const LEAVE_REPORT = `${HOST}/api/cap-admin/report/get/leave-report`
export const WORK_REPORT = `${HOST}/api/cap-admin/report/get`
export const ATTENDANCE_REPORT = `${HOST}/api/cap-admin/report/get/attendance-report`
